
import { defineComponent, PropType } from 'vue'
import {
  Project,
  VISIBILITY,
} from '../types'

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Cards',
  props: {
    projects: {
      type: Array as PropType<Project[]>,
      required: true
    }
  },
  data: () => ({
    VISIBILITY
  })
});
